<div class="benchmarks-container">
  <div class="header">
    <h2 i18n="@@benchmarks.list.title">Benchmarks</h2>
    <p-button
      icon="pi pi-plus"
      i18n-label="@@benchmarks.list.add"
      label="New benchmark"
      severity="primary"
      (click)="onAddClick()"
      [disabled]="isLoading()">
    </p-button>
  </div>

  @if (isLoading()) {
    <div class="loading-container">
      <p-progressSpinner styleClass="loading-spinner"></p-progressSpinner>
      <p i18n="@@benchmarks.list.loading">Загрузка бенчмарков...</p>
    </div>
  } @else {
    <div class="filter-container">
      <div class="search-input-wrapper">
        <i class="pi pi-search search-icon"></i>
        <input
          pInputText
          type="text"
          [ngModel]="searchQuery()"
          (ngModelChange)="searchQuery.set($event)"
          i18n-placeholder="@@benchmarks.list.search"
          placeholder="Поиск по названию или описанию..."
          class="search-input" />
      </div>
      <p-select
        [ngModel]="typeFilter()"
        (ngModelChange)="typeFilter.set($event)"
        [options]="typeOptions"
        optionLabel="label"
        optionValue="value"
        styleClass="type-filter">
      </p-select>
    </div>

    <div class="table-container">
      <p-table [value]="filtered()" styleClass="benchmarks-table">
        <ng-template pTemplate="header">
          <tr>
            <th class="hide-mobile" style="width: 6rem;" i18n="@@benchmarks.list.col.type">Type</th>
            <th i18n="@@benchmarks.list.col.title">Title</th>
            <th class="hide-mobile" i18n="@@benchmarks.list.col.description">Description</th>
            <th class="hide-mobile" style="width: 6rem; text-align: center;" i18n="@@benchmarks.list.col.iterations">Iters</th>
            <th class="hide-mobile" style="width: 6rem; text-align: center;" i18n="@@benchmarks.list.col.versions">Versions</th>
            <th class="hide-mobile" style="width: 6rem; text-align: center;" i18n="@@benchmarks.list.col.samples">Samples</th>
            <th class="hide-mobile" style="width: 6rem; text-align: center;" i18n="@@benchmarks.list.col.auto">Auto</th>
            <th class="hide-mobile" style="width: 11rem;" i18n="@@benchmarks.list.col.updated">Updated</th>
            <th style="width: 10rem; text-align: center;" i18n="@@benchmarks.list.col.actions">Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-b>
          <tr>
            <td class="hide-mobile">
              <p-tag
                [value]="(b.model_type_code || '').toUpperCase()"
                [severity]="typeSeverity(b.model_type_code)"
                [rounded]="true">
              </p-tag>
            </td>
            <td>
              <strong>{{ b.title || '—' }}</strong>
            </td>
            <td class="hide-mobile description-cell">{{ b.description || '—' }}</td>
            <td class="hide-mobile" style="text-align: center;">{{ b.iterations ?? '—' }}</td>
            <td class="hide-mobile" style="text-align: center;">{{ b.model_version_count ?? 0 }}</td>
            <td class="hide-mobile" style="text-align: center;">
              @if ((b.model_type_code || '').toLowerCase() === 'stt') {
                {{ b.stt_sample_count ?? 0 }}
              } @else {
                —
              }
            </td>
            <td class="hide-mobile" style="text-align: center;">
              @if (b.auto_benchmark_enabled) {
                <i class="pi pi-check-circle" style="color: var(--p-primary-color)"
                   pTooltip="Auto-benchmark включён" i18n-pTooltip="@@benchmarks.list.autoOn"></i>
              } @else {
                <i class="pi pi-circle" style="color: var(--p-text-muted-color)"
                   pTooltip="Auto-benchmark выключён" i18n-pTooltip="@@benchmarks.list.autoOff"></i>
              }
            </td>
            <td class="hide-mobile">{{ formatDate(b.updated_at) }}</td>
            <td style="text-align: center;">
              <div class="row-actions">
                <p-button
                  icon="pi pi-bolt"
                  severity="warn"
                  [text]="true"
                  [rounded]="true"
                  [loading]="isRunning(b.id)"
                  [disabled]="isRunning(b.id)"
                  pTooltip="Запустить бенч"
                  i18n-pTooltip="@@benchmarks.list.run.tooltip"
                  (click)="onRunClick(b, $event)"
                  i18n-ariaLabel="@@benchmarks.list.run.tooltip"
                  ariaLabel="Запустить бенч">
                </p-button>
                <p-button
                  icon="pi pi-pencil"
                  severity="secondary"
                  [text]="true"
                  [rounded]="true"
                  pTooltip="Редактировать"
                  i18n-pTooltip="@@benchmarks.list.edit.tooltip"
                  (click)="onEditClick(b)"
                  i18n-ariaLabel="@@benchmarks.list.edit.tooltip"
                  ariaLabel="Редактировать">
                </p-button>
                <p-button
                  icon="pi pi-trash"
                  severity="danger"
                  [text]="true"
                  [rounded]="true"
                  pTooltip="Удалить"
                  i18n-pTooltip="@@benchmarks.list.delete.tooltip"
                  (click)="onDeleteClick(b)"
                  i18n-ariaLabel="@@benchmarks.list.delete.tooltip"
                  ariaLabel="Удалить">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="9" style="text-align: center;" i18n="@@benchmarks.list.empty">
              Бенчмарки ещё не заведены. Нажмите «New benchmark», чтобы создать первый.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }

  <!-- Run: стандартный PrimeNG конфирм (attach к кнопке). Delete:
       наш шарный <app-delete-confirmation> с загрузчиком. -->
  <p-confirmDialog></p-confirmDialog>
  <app-delete-confirmation
    [visible]="deleteVisible()"
    [deleting]="isDeleting()"
    [title]="deleteTarget()?.title ? 'Удалить «' + (deleteTarget()!.title) + '»?' : 'Удалить бенч?'"
    [subtitle]="'Удаление бенча снимет все связи с версиями моделей и историю прогонов. Действие необратимо.'"
    (confirm)="onDeleteConfirm()"
    (cancel)="onDeleteCancel()"
    (visibleChange)="deleteVisible.set($event)">
  </app-delete-confirmation>
</div>
